import { ActionPointInfo, Controller, IActionPointInfo, MainMenu, Menu, Toolbar } from '@tencent/workbench';
import { SlideSizeFeature } from './slide-size-feature';
import { config169, config43, configCustom, MENU_CONFIGS, TOOLBAR_ITEMS, toolbarConfig } from './config';
import { MenuKey, PREFIX } from '@framework/workbench/schema/menu-schema/common';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { STSlideSizeType } from '@tencent/slide-sdk-pb-model/src/ultrabuf/ultrabuf.types';
import * as React from 'react';

/**
 * 设置幻灯片比例
 */
@Controller({
    menuItems: MENU_CONFIGS,
    toolbarItems: TOOLBAR_ITEMS,
})
export class SlideSizeController {
    constructor(private readonly feature: SlideSizeFeature) {
    }

    @Menu(config43.id, 'onClick')
    @Menu(config169.id, 'onClick')
    @Menu(MenuKey.SLIDE_STANDARD, 'onClick')
    @Menu(MenuKey.SLIDE_WIDE, 'onClick')
    public onClick(@ActionPointInfo() info:  IActionPointInfo) {
        const { name } = info;
        const slideSizeType = this.feature.getUiDataService().presentation?.props.type;
        const mapName = this.getUiTypeMap(slideSizeType);
        if (mapName === name) return;

        this.feature.getAppService().editableServiceLayer?.slideSizeService?.promise().then((module) => {
            const sdkType = this.getSdkTypeMap(name);
            if (sdkType) {
                module.showSlideSizeConfirmDialog(sdkType);
            }
        });
    }

    public getUiTypeMap(type: STSlideSizeType | undefined) {
        if (type === STSlideSizeType.screen4x3) return config43.id;
        if (type === STSlideSizeType.screen16x9) return config169.id;
    }

    public getSdkTypeMap(type: string) {
        if (type === ActionType.SLIDE_WIDE) return STSlideSizeType.screen16x9;
        if (type === ActionType.SLIDE_STANDARD) return STSlideSizeType.screen4x3;
    }

    @Menu(configCustom.id, 'onClick')
    public onCustomClick(@ActionPointInfo() info:  IActionPointInfo) {
        this.feature.getAppService().editableServiceLayer?.slideSizeService?.promise().then((module) => {
            module.showSlideSizeDialog();
        });
    }

    /**
     * 顶栏的比例设置选中，比工具栏多了自定义比例
     * @param info
     */
    @Menu(MenuKey.SLIDE_WIDE, 'shouldCheck')
    @Menu(MenuKey.SLIDE_STANDARD, 'shouldCheck')
    @Menu(ActionType.SLIDE_CUSTOM, 'shouldCheck')
    @Menu(config43.id, 'shouldCheck')
    @Menu(config169.id, 'shouldCheck')
    public topMenuShouldCheck(@ActionPointInfo() info:  IActionPointInfo) {
        let { name } = info;
        if (info.name.indexOf(PREFIX) !== -1) {
            name = info.name.replace(PREFIX, '');
        }

        const slideSizeType = this.feature.getUiDataService().presentation?.props.type;
        let type;
        switch (slideSizeType) {
            case STSlideSizeType.screen16x9:
                type = config169.id;
                break;
            case STSlideSizeType.screen4x3:
                type = config43.id;
                break;
            default:
                type = configCustom.id;
        }
        return name === type;
    }

    /**
     * 只有导入自定义比例的幻灯片时，才会在顶栏的页面设置中显示自定义
     * 工具栏没有这个逻辑
     * @param info
     */
    // @Menu(ActionType.SLIDE_CUSTOM, 'shouldHide')
    // public customShouldHide(@ActionPointInfo() info:  IActionPointInfo) {
    //     const slideSizeType = this.feature.getUiDataService().presentation?.props.slideSizeType;
    //     return slideSizeType !== SlideSizeType.SLIDE_SIZE_CUSTOM;
    // }

    @Toolbar(toolbarConfig.id, 'dropdownContent')
    public insertDropdown() {
        return <MainMenu
            align="left" name={toolbarConfig.id} mode="menu" itemStyle={{ width: 166 }} />;
    }
}
